import { render, staticRenderFns } from "./TDaccount.vue?vue&type=template&id=94aa3c0e&scoped=true"
import script from "./TDaccount.vue?vue&type=script&lang=js"
export * from "./TDaccount.vue?vue&type=script&lang=js"
import style0 from "./TDaccount.vue?vue&type=style&index=0&id=94aa3c0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aa3c0e",
  null
  
)

export default component.exports